import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { Box, Button, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { ModalActionProps } from 'models/AutoModals';


type DateDialogProps = {
    description?: React.ReactNode,
    required?: boolean,
    defaultDate?: string | DateTime | null,
} & ModalActionProps<string>;

const DateDialog = ({description, required, defaultDate, onFinish}: DateDialogProps) => {
    const {t} = useTranslation();
    const [date, setDate] = useState<DateTime | null | undefined>(typeof defaultDate === 'string' ?
        DateTime.fromISO(defaultDate) : defaultDate
    );

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        date && onFinish(date.toISODate()!);
    };

    return (
        <Box component="form" onSubmit={submit}>
            {description && (
                <DialogContent>
                    <DialogContentText>{description}</DialogContentText>
                </DialogContent>
            )}

            <DialogContent>
                <DatePicker
                    format="yyyy-MM-dd"
                    slotProps={{ textField: { fullWidth: true, required: required } }}
                    onChange={d => setDate(d!)}
                    value={date}
                    label={t('date')}
                />
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('apply')}</Button>
            </DialogActions>
        </Box>
    );
};

export default DateDialog;
